import React from 'react';
import classNames from 'classnames';
import { Button, Form, Input, message } from 'antd';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'hooks';
import { BlackLogo } from 'components/molecules';
import { formValidation } from 'utils/form-utils';
import './index.scss';

const cx = classNames.bind('./index.scss');

export interface RegisterProps {}

const Register = ({}: React.PropsWithChildren<RegisterProps>): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const [form] = Form.useForm();
  const { register } = useAuth();
  const location = useLocation();

  /* ======================================================
   * events
   * ====================================================== */
  const onClickRegister = () => {
    const email = form.getFieldValue('email') as string;
    if (!email.toLowerCase().endsWith('@hsg.or.kr')) {
      message.error("가입 불가능한 메일 주소 입니다.", 1);
      return;      
    }
    if (form.getFieldValue('password') !== form.getFieldValue('passwordconfirm')) {
      message.error("비밀번호를 다시 확인 부탁 드립니다.", 1);
      return;
    }

    register({ username: form.getFieldValue('username'), email: form.getFieldValue('email'), password: form.getFieldValue('password') });
  };

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('registerPage')}>
      <div className={cx('registerContainer')}>
        <div style={{display:"flex", justifyContent:"space-between"}}>
          <BlackLogo />
          <h3 style={{color:"#039"}}>사용자 등록신청</h3>
        </div>
        <h2 className={cx('welcomemsg')}>사용자 등록신청 후 관리자<br />승인이 되어야 사용 가능 합니다.</h2>
        <Form form={form} onFinish={() => {}} style={{ width: '100%' }} requiredMark={false} labelCol={{ span: 8 }}>
          <Form.Item name="username" label="이름">
            <Input autoComplete="off" placeholder='이름를 입력하세요' />
          </Form.Item>
          <Form.Item name="email" label="이메일">
            <Input autoComplete="off" placeholder='이메일을 입력하세요' />
          </Form.Item>
          <Form.Item name="password" label="비밀번호">
            <Input type="password" placeholder='비밀번호를 입력하세요' />
          </Form.Item>
          <Form.Item name="passwordconfirm" label="비밀번호 확인">
            <Input type="password" placeholder='비밀번호를 재입력하세요' />
          </Form.Item>              
          <Form.Item style={{ marginTop: "30px" }} shouldUpdate>
            {() => (
              <Button htmlType="submit" type="primary" onClick={onClickRegister} disabled={!formValidation(form, [])} style={{width: "100%"}}>
                등록신청
              </Button>
            )}
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Register;
